
































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { State } from "vuex-class";
import logger from "@/configs/logger";
import * as api from "@/lib/api";
import { objectify } from "@/helpers";
import { User } from "@/types";
import featureConfig from "@/helpers/featureConfigs";

@Component
export default class CreateAgent extends Vue {
  @State("user") user!: User;
  success: boolean = false;
  loading: boolean = false;
  valid: boolean = true;
  agentInfos: any = {};
  rules = {
    password: {
      required: (v: string) => !!v || "Password is required.",
      min: (v: string) => (v && v.length >= 8) || "Min 8 characters"
    }
  };

  get groups() {
    if (this.user.roles.includes("admin")) {
      return featureConfig.getGroupTypes();
    }
    return featureConfig
      .getGroups(this.user.groups)
      .filter(group => !!group.groupSupervising)
      .map(group => group.groupSupervising);
  }

  get form(): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean };
  }

  getRolesFromGroups(groups: Array<string>): Array<string> {
    const roles = new Set<string>();
    featureConfig.getGroups(groups).forEach(group => {
      if (group.groupType) {
        roles.add(group.groupType);
      }
    });
    return Array.from(roles);
  }

  async submit() {
    this.form.validate();
    this.success = false;
    if (this.valid) {
      try {
        this.loading = true;
        const payload = {
          ...this.agentInfos,
          roles: this.getRolesFromGroups(this.agentInfos.groups)
        };
        await api.adminCreateUser(payload);
        window.console.log(payload);
        this.success = true;
        this.agentInfos = {};
        //@ts-ignore
        this.$refs.form.reset();
      } catch (err) {
        logger("error", "create user error", err);
        this.success = false;
        const res = objectify(err.response).data;
        if (res && res.error) {
          this.$toasted.error(err.response.data.error);
        } else {
          this.$toasted.error("Create User error!");
        }
      } finally {
        this.loading = false;
      }
    }
  }

  handleInputChange(key: string, val: string) {
    if (!val || !key) return;
    if (key === "auto_accept") {
      this.agentInfos[key] = val === "true";
    } else {
      this.agentInfos[key] = val;
    }
  }
}
